import { Instagram } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export const InstagramFeed = () => {
  const { content } = useContent();
  const posts = content?.instagram_posts || [];
  const s = content?.settings || {};
  if (!posts.length) return null;
  if (s.section_visibility && s.section_visibility["home_instagram"] === false) return null;

  return (
    <section className="section-pad bg-[#1A1615]" data-testid="instagram-section">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Reveal><p className="eyebrow text-[#D4AF37]">Follow the Glow</p></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-3 font-serif text-3xl font-medium text-white sm:text-4xl">@royalskincosmeticclinic</h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <a
              href={s.instagram || "https://www.instagram.com/royalskincosmeticclinic/"}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-link"
              className="btn-ghost-lux border-[#D4AF37]/40 px-6 py-3 text-sm text-[#F3E5AB] hover:bg-[#D4AF37]/10"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" /> Follow on Instagram
            </a>
          </Reveal>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6" data-testid="instagram-grid">
          {posts.slice(0, 6).map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <a
                href={p.link || s.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-post-${p.id}`}
                className="group relative block overflow-hidden rounded-2xl"
                aria-label={p.caption || "Instagram post"}
              >
                <img
                  src={p.image}
                  alt={p.caption || "Royal Skin Cosmetic Clinic Instagram post"}
                  loading="lazy"
                  className="aspect-square w-full object-cover transition-transform duration-700 ease-liquid group-hover:scale-110"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-[#1A1615]/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <Instagram className="h-6 w-6 text-[#F3E5AB]" aria-hidden="true" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 text-center text-xs font-light text-[#A39288]">
            Highlights curated by our team — follow us for daily transformations and skin wisdom.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
